import React, { FC } from 'react'

const Filer:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/filter.png" alt=''/>
        </div>
    </div>
  )
}

export default Filer